<div class="select-search-block" [class.padding-bottom]="checkIsDelFiled() && group?.get(field.name).valid">
    <mat-form-field
        class="form-full-width"
        appearance="outline"
        [formGroup]="group"
        [class.load-spinner-select]="isDataLoad"
        [class.remove-option-select-field]="checkIsDelFiled()"
    >
        <i
            matPrefix
            *ngIf="field?.leadingIcon"
            [ngClass]="'mdi mdi-' + field?.leadingIcon"
            class="select_leading-icon"
        ></i>
        <mat-label>{{ field.label }}</mat-label>
        <fui-button
            class="select_trailing-button"
            icon="chevron-down"
            type="button-icon"
            height="mini"
            borderRadius="circle"
            color="neutral"
            [disabled]="field.disabled"
        >
        </fui-button>
        <mat-progress-spinner
            *ngIf="isDataLoad && field.isReload"
            class="mat-progress-spinner-select_load"
            matSuffix
            color="primary"
            mode="indeterminate"
            diameter="35"
        >
        </mat-progress-spinner>
        <mat-select
            #matSelect
            [formControl]="group.get(field.name)"
            (click)="eventUpdateList.next(field.reloadParam); isDataLoad = true"
            [disableOptionCentering]="true"
            [panelClass]="data.length > appService.hideSelectOptions ? '' : 'not-padding-mat-select-search-panel'"
            [multiple]="field.multiple"
            [fuiTooltip]="tooltip | async"
        >
            <ng-container *ngIf="data.length > appService.hideSelectOptions">
                <mat-option class="search-option">
                    <ngx-mat-select-search
                        [disableInitialFocus]="!deviceService.isDesktop()"
                        [formControl]="filterCtrl"
                        [cdkTrapFocus]="false"
                        [showToggleAllCheckbox]="field.multiple"
                        (toggleAll)="toggleSelectAll($event)"
                        [toggleAllCheckboxChecked]="toggleAllCheckboxChecked()"
                        [toggleAllCheckboxIndeterminate]="toggleAllCheckboxIndeterminate()"
                        placeholderLabel="{{ appService.language_dictionary.system_search }}"
                        noEntriesFoundLabel="{{ appService.language_dictionary.system_no_options_found }}"
                        [clearSearchInput]="true"
                    >
                        <!-- Кнопка добавить для случая, когда есть поиск и ничего не нашлось -->
                        <div class="mat-select-search-custom-header-content text-on-surface absolute top-2.5 right-11">
                            <ng-container *ngIf="field.buttonAdd && (filteredSelect | async)?.length === 0">
                                <fui-button
                                    (clickEvent)="eventAdd.next(filterCtrl.value)"
                                    [label]="appService.language_dictionary.system_add_in_registry"
                                    color="soft"
                                    height="slim"
                                    icon="plus"
                                >
                                </fui-button
                            ></ng-container>
                        </div>

                        <mat-icon
                            ngxMatSelectSearchClear
                            fontSet="mdi"
                            fontIcon="mdi-close"
                            [inline]="true"
                            [title]="appService.language_dictionary.system_clear"
                        ></mat-icon>
                    </ngx-mat-select-search>
                </mat-option>
            </ng-container>
            <!-- Опция НЕ ЗАДАНО -->
            <ng-container *ngIf="!field.multiple && !field.required">
                <mat-option
                    [value]=""
                    (click)="group.get(field.name).setValue(null); group?.get(field.name)?.markAsDirty()"
                >
                    {{ appService.language_dictionary.system_not_specified_upp_case }}
                </mat-option>
            </ng-container>
            <!-- Список обычных опций -->
            <ng-container *ngFor="let option of filteredSelect | async">
                <div fxLayout="column">
                    <mat-option
                        #matOption
                        fxFill
                        fxFlex="1 1"
                        [value]="option.id"
                        [disabled]="field.multiple ? checkIsDel(option) && !matOption.selected : checkIsDel(option)"
                        [class.add-tree-hyphen]="field.addTreeHyphen"
                        [class.remove-option-select]="checkIsDel(option)"
                        [matTooltip]="getOptionName(option)"
                    >
                        <ng-container *ngIf="field.addTreeHyphen && option.level">
                            <ng-container *ngFor="let level of [].constructor(option.level)">
                                &nbsp;&nbsp;
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="option?.icon; else nonIconTempalate">
                            <div class="select-div">
                                <span class="select-icon"><i [class]="option?.icon"></i></span>
                                {{ getOptionName(option) }}
                            </div>
                        </ng-container>

                        <ng-template #nonIconTempalate>
                            {{ getOptionName(option) }}
                        </ng-template>
                    </mat-option>
                    <!-- Указатель на удаленный элемент -->
                    <ng-container *ngIf="checkIsDel(option)">
                        <div class="remove-option-title">
                            {{ appService.language_dictionary.item_deleted }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <!-- Кнопка добавить для случая, когда есть поиска нет -->
            <ng-container *ngIf="field.buttonAdd && data.length <= appService.hideSelectOptions">
                <div class="p-2">
                    <fui-button
                        (clickEvent)="eventAdd.next('')"
                        [label]="appService.language_dictionary.system_add_in_registry"
                        color="soft"
                        height="slim"
                        icon="plus"
                    >
                    </fui-button>
                </div>
            </ng-container>
        </mat-select>
        <ng-container *ngFor="let validation of field?.validations" ngProjectAs="mat-error">
            <mat-error
                *ngIf="group?.get(field.name)?.hasError(validation.name)"
                [innerHTML]="
                    validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
                "
            >
            </mat-error>
        </ng-container>
        <ng-container *ngIf="isUseInvalidValue && group?.get(field.name).valid">
            <mat-error class="invalid-value-message">
                {{ appService.language_dictionary.replace_value_in_field }}
            </mat-error>
        </ng-container>
        <mat-hint
            *ngIf="this.field.hint"
            [innerHtml]="this.field.hint"
            [ngClass]="'select_tooltip'"
            [title]="this.field.hint"
        ></mat-hint>
    </mat-form-field>
</div>
